import { createProductVariationDropdown } from "../components/product/variation-dropdown";
import { createProductBundle } from "../components/product/bundle";
import { createProductGallery } from "../components/product/product-gallery";
import { createQuantityInput } from "../components/product/quantity-input";
import { createCartPopup } from "../components/cart-popup";
import { createAddToCart } from "../components/product/add-to-cart";
import { createProductFields } from "../components/product/product-fields";
import { addToCart, addBundleToCart } from "../services/cart";

jQuery(function ($) {
  const components = {
    productGallery: createProductGallery(
      $("[data-component='product-gallery']")
    ),
    productBundle: createProductBundle($("[data-component='product-bundle']")),
    variationDropdown: createProductVariationDropdown(
      $("[data-component='product-variation-dropdown']")
    ),
    quantityInput: createQuantityInput($("[data-component='quantity-input']")),
    addToCart: createAddToCart($("[data-component='add-to-cart']")),
  };

  if (components.variationDropdown) {
    components.variationDropdown.addChangeHandler((event, variation) => {
      if (
        components.productGallery &&
        variation.image &&
        variation.image.full_src
      ) {
        components.productGallery.updateMainImage(variation.image);
      }
      if (components.productBundle) {
        components.productBundle.updateCurrentProduct({
          priceHtml: variation.price_html,
          image: variation.image,
        });
      }
    });
  }

  // Initialize product custom fields
  const productFieldsElements = $("[data-component='product-fields']");
  if (productFieldsElements.length > 0) {
    components.productFields = createProductFields(productFieldsElements[0]);
  }

  /**
   * Validate current product selections (variation and custom fields)
   * @returns {Object} - { isValid: boolean, fieldData: object }
   */
  const validateProductSelections = () => {
    // Validate variation selection
    if (
      components.variationDropdown &&
      components.variationDropdown.getValue() === ""
    ) {
      alert(wc_add_to_cart_variation_params.i18n_make_a_selection_text);
      return { isValid: false, fieldData: {} };
    }

    // Validate custom fields if they exist
    let fieldData = {};
    if (components.productFields) {
      if (!components.productFields.validate()) {
        return { isValid: false, fieldData: {} };
      } else {
        fieldData = components.productFields.getValues();
      }
    }

    return { isValid: true, fieldData };
  };

  // Add to cart button click handler
  if (components.addToCart) {
    components.addToCart.addClickHandler(async (e) => {
      e.preventDefault();

      // Validate product selections
      const { isValid, fieldData } = validateProductSelections();
      if (!isValid) return;

      components.addToCart.loading(hs.strings.addingToCart);
      let productId = components.addToCart.getProductId();
      const variationId = components.addToCart.getVariationId() || 0;

      // If product ID is still undefined but we're on a product page, try to get it from the form
      if (!productId) {
        productId = $("form.cart, form.variations_form").data("product_id");
      }

      if (productId && productId != 0) {
        const quantity = components.quantityInput.getValue();
        const response = await addToCart(
          productId,
          quantity,
          variationId,
          fieldData
        );
        if (response.success) {
          createCartPopup(productId, variationId);
          components.addToCart.done();
          components.addToCart.hide();
          components.addToCart.showVisitCartButton();
        } else {
          components.addToCart.done();
          alert(response.data?.message || "Error adding product to cart");
        }
      } else {
        // Handle error case when product ID is still missing
        components.addToCart.done();
        console.error("Failed to determine product ID for add to cart action");
        alert(hs.strings.errorAddingToCart || "Error adding product to cart");
      }
    });
  }

  // Bundle add to cart handler
  if (components.productBundle) {
    components.productBundle.addClickHandler(async (e) => {
      // Validate product selections first
      const { isValid, fieldData } = validateProductSelections();
      if (!isValid) return;

      components.productBundle.loading(hs.strings.addingToCart);
      const selectedProducts = components.productBundle.getSelectedProducts();

      if (selectedProducts.length > 0) {
        // Get variation ID if available
        const variationId = components.addToCart.getVariationId() || 0;
        const response = await addBundleToCart(
          selectedProducts,
          variationId,
          fieldData
        );

        if (response.success) {
          window.location.href = response.data.cart_url;
        } else {
          components.productBundle.done();
          alert(response.data?.message || "Error adding bundle to cart");
        }
      } else {
        components.productBundle.done();
      }
    });
  }

  // Handle floating add-to-cart bar
  (function () {
    const $floatingCart = $(".js-floating-add-to-cart-bar");
    const $mainAddToCartButton = $(".cart");

    if (!$floatingCart.length || !$mainAddToCartButton.length) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.boundingClientRect.top < 0) {
          const nearBottom =
            $(window).scrollTop() + $(window).height() >= $(document).height();

          $floatingCart.css("display", nearBottom ? "none" : "block");
        } else {
          $floatingCart.css("display", "none");
        }
      },
      {
        root: null,
        threshold: [0, 1],
        rootMargin: "0px",
      }
    );

    observer.observe($mainAddToCartButton[0]);

    // Check of we bij de onderkant van de pagina zijn
    $(window).on("scroll", function () {
      if ($mainAddToCartButton[0].getBoundingClientRect().top < 0) {
        const nearBottom =
          $(window).scrollTop() + $(window).height() >= $(document).height();

        $floatingCart.css("display", nearBottom ? "none" : "block");
      }
    });
  })();
});
